import { z } from 'zod';
import { BankAccountPayload, BaseBankAccountPayloadSchema } from './bank-account.payload.entity';

export const RtgsBankAccountPayloadSchema = BaseBankAccountPayloadSchema.merge(
    z.object({
        accountNumber: z.string(),
        bankCode: z.string(),
        branchCode: z.string(),
    }),
);

export class RtgsBankAccountPayload extends BankAccountPayload {
    accountNumber: string;
    bankCode: string;
    branchCode: string;
}
